import type { KitchenTicketWithDetails } from "../../domain/types";

type KitchenTicketItemProps = {
  item: KitchenTicketWithDetails["items"][number];
};

export function KitchenTicketItemComponent({ item }: KitchenTicketItemProps) {
  return (
    <div className="flex items-center justify-between border-b pb-2 last:border-b-0">
      <div className="flex-1">
        <p className="font-medium text-sm">{item.displayName}</p>
        {item.variantOptions && item.variantOptions.length > 0 && (
          <div className="mt-0.5 space-y-0.5">
            {item.variantOptions.map((opt) => (
              <p
                key={`${opt.optionName}-${opt.optionValue}`}
                className="text-muted-foreground text-xs"
              >
                {opt.optionName}: <strong>{opt.optionValue}</strong>
              </p>
            ))}
          </div>
        )}
        {item.modifiers && item.modifiers.length > 0 && (
          <div className="mt-0.5 space-y-0.5">
            {item.modifiers.map((modifier) => (
              <p
                key={modifier.id}
                className="text-muted-foreground text-xs"
              >
                + {modifier.optionLabel ? `${modifier.label}: ${modifier.optionLabel}` : modifier.label}
              </p>
            ))}
          </div>
        )}
        {item.note && (
          <p className="mt-1 text-muted-foreground text-xs italic">
            <strong>ໝາຍເຫດ:</strong> {item.note}
          </p>
        )}
      </div>
      <div className="ml-4 text-right">
        <p className="font-semibold text-sm">x{item.quantity}</p>
      </div>
    </div>
  );
}
